/**
 * Url定数
 */
export class Url {
  /** 基底URL、ログイン画面を指す */
  public static readonly Root: string = "/";

  /** メンテナンス */
  public static readonly Maintenance: string = "/maintenance";
  /** システムエラー */
  public static readonly SystemError: string = "/system-error";
  /** ネットワークエラー */
  public static readonly NetworkError: string = "/network-error";
  /** サポート外ブラウザ */
  public static readonly UnsupportedAgent: string = "/unsupported";
  /** 404 NotFound */
  public static readonly NotFound: string = "/404";
}
